/**
 * Telegram's in-app viewer for a collectible gift (owner, attributes, history).
 * `slug` is the same id used everywhere (e.g. "LolPop-12345").
 */
export function getTelegramGiftViewerUrl(slug: string): string {
  return `https://t.me/nft/${slug}`
}
